import React from 'react';
import { Button, Flex, Splitter, Typography } from 'antd';
import type { SplitterProps } from 'antd';

const Desc: React.FC<Readonly<{ text?: string | number }>> = (props) => (
  <Flex justify="center" align="center" style={{ height: '100%' }}>
    <Typography.Title type="secondary" level={5} style={{ whiteSpace: 'nowrap' }}>
      {props.text}
    </Typography.Title>
  </Flex>
);

const App: React.FC = () => {
  const [sizes, setSizes] = React.useState<(number | string)[]>([150, 150]);
  const handleExpand = () => {
    setSizes([150, 150])
  }
  return (
    <Flex gap="middle" vertical>
      <Button onClick={handleExpand}>展开</Button>
      <Splitter onResize={setSizes} style={{ boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', height: 300 }} layout="vertical">
        <Splitter.Panel collapsible min="100" size={sizes[0]} resizable>
          <Desc text="First" />
        </Splitter.Panel>
        <Splitter.Panel collapsible min="100" size={sizes[1]} resizable>
          <Desc text="Second" />
        </Splitter.Panel>
      </Splitter>
    </Flex>
  )
};

export default App;